/***
 * @file:
 * @Date: 2020-09-02 11:32:46
 * @author: manyao.zhu
 */
export const Data = [
  {
    icon: '/img/wechat.png',
    icon_alive: '/img/alive-wechat.png',
    iconId: '',
    bindFlag: '1',
    bindTitle: 'å¾®ä¿¡',
    scriptUrl: 'http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js',
    scriptConfig:
      'new WxLogin({self_redirect:false,id:"weixin",appid:"wxe4e2b3e22868f4de",scope:"snsapi_login",redirect_uri:encodeURI("http://sso.qa.ithinkdt.com/pub/weixin/login"),state:"",style:"",href:""});',
    windowOpenUri: null,
    title: 'å¾®ä¿¡ç»å½',
    authKind: 'weixin',
  },
  {
    icon: '/img/wwchat.png',
    icon_alive: '/img/alive-wwchat.png',
    iconId: '',
    bindFlag: '0',
    bindTitle: 'ä¼ä¸å¾®ä¿¡',
    scriptUrl: 'http://rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js',
    scriptConfig:
      'new WwLogin({id:"wwchat",appid:"ww6131e8c2746b7eb3",agentid:"1000013",redirect_uri:encodeURI("http://sso.qa.ithinkdt.com/pub/wwchat/login"),state:"",href:""});',
    windowOpenUri: null,
    title: 'ä¼ä¸å¾®ä¿¡ç»å½',
    authKind: 'wwchat',
  },
  {
    icon: '/img/feishu.png',
    icon_alive: '/img/alive-feishu.png',
    iconId: '',
    bindFlag: '0',
    bindTitle: 'é£ä¹¦',
    scriptUrl: null,
    scriptConfig: null,
    windowOpenUri:
      'https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=http://sso.qa.ithinkdt.com/pub/feishu/login&app_id=cli_9e39278bf9fed00d&state=abc',
    title: 'é£ä¹¦ç»å½',
    authKind: 'feishu',
  },
];
